import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { EmailSubscriptionForm } from '.';

const LOCAL_STORAGE_KEY = 'emailPopupShown';

const EmailSubscriptionModal: React.FC = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!hasSeenPopup) {
      setOpen(true);
      localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Subscribe to our newsletter</DialogTitle>
      <DialogContent>
        <EmailSubscriptionForm />
      </DialogContent>
    </Dialog>
  );
};

export default EmailSubscriptionModal;
